const DEVANAGARI = /[\u0900-\u097F]/u;

export function containsDevanagari(value) {
  return DEVANAGARI.test(String(value ?? ''));
}

export function englishOnlyText(value, fallback = 'Non-English source text hidden') {
  const text = String(value ?? '');
  return containsDevanagari(text) ? fallback : text;
}

export function acceptEnglishInput(value) {
  const text = String(value ?? '');
  return containsDevanagari(text) ? null : text;
}
